import { AppModule } from '@/shared/types';
import * as routes from './routes';

export const OnboardingModule: AppModule = {
  routes,
};
